const AdaptSex = [{
		key: '不限',
		value: '3'
	},
	{
		key: '男',
		value: '1'
	},
	{
		key: '女',
		value: '2'
	}
];
const Sex = [{
		key: '男',
		value: '1'
	},
	{
		key: '女',
		value: '2'
	}
];
const AdaptMarry = [{
		key: '不限',
		value: '3'
	},
	{
		key: '已婚',
		value: '1'
	},
	{
		key: '未婚',
		value: '2'
	}
];
const Marry = [{
		key: '请选择',
		value: '0'
	},
	{
		key: '已婚',
		value: '1'
	},
	{
		key: '未婚',
		value: '2'
	}
];
const CorpType = [{
		key: '体检中心',
		value: '0'
	},
	{
		key: '医院',
		value: '1'
	}
];
const RoleType = [{
		key: '普通用户',
		value: '0'
	},
	{
		key: '管理员',
		value: '1'
	},
	{
		key: '超级管理员',
		value: '2'
	}
];
const BookTimeStep = [{
		key: '7:30-8:30',
		value: '0'
	},
	{
		key: '8:30-9:30',
		value: '1'
	},
	{
		key: '9:30-10:30',
		value: '2'
	}
];
const BookStatus = [{
		key: '预约成功',
		value: '1'
	},
	{
		key: '取消预约',
		value: '2'
	}
];
const OrderState = [{
		key: '全部',
		value: -1
	}, {
		key: '创建订单',
		value: 0
	},
	{
		key: '提交订单',
		value: 1
	},
	{
		key: '审核通过',
		value: 2
	},
	{
		key: '可以体检',
		value: 3
	}
];
const CusStatus = [{
		key: '名单导入',
		value: '10'
	},
	{
		key: '游客添加',
		value: '11'
	},
	{
		key: '已通知预约',
		value: '20'
	},
	{
		key: '已支付',
		value: '25'
	},
	{
		key: '预约成功',
		value: '30'
	},
	{
		key: '取消预约',
		value: '40'
	},
	{
		key: '已体检',
		value: '50'
	},
	{
		key: '已出报告',
		value: '55'
	}
];
const PayType = [{
		key: '单位统结',
		value: '0'
	},
	{
		key: '个人自费',
		value: '1'
	},
	{
		key: '部分统结',
		value: '2'
	}
];
const ShopOrderStatus = [{
		key: '待支付',
		value: '0'
	},
	{
		key: '已支付',
		value: '1'
	},
	{
		key: '申请退款',
		value: '2'
	},
	{
		key: '已退款',
		value: '3'
	}
];

export function GetEnumNameByValue(em, value) {
	var i = 0;
	var len = em.length;
	for (; i < len; i++) {
		if (em[i].value == value) {
			return em[i].key;
		}
	}
}
export default {
	RoleType,
	CorpType,
	GetEnumNameByValue,
	AdaptMarry,
	AdaptSex,
	Sex,
	Marry,
	BookTimeStep,
	BookStatus,
	OrderState,
	CusStatus,
	PayType,
	ShopOrderStatus
}
